import { useAuth0 } from '@auth0/auth0-react';
import { PersonOutlineOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Login = (): JSX.Element => {
  const { t } = useTranslation('component');
  const { loginWithRedirect } = useAuth0();

  return (
    <>
      {t('NavBarConnection.ConnectionQuestion')}
      <Button
        sx={{ marginLeft: '5px', fontWeight: 'bold', zIndex: 10 }}
        color="inherit"
        variant="text"
        id="RegisterLogInButton"
        startIcon={<PersonOutlineOutlined />}
        onClick={() => loginWithRedirect()}>
        {t('NavBarConnection.ConnectionLink')}
      </Button>
    </>
  );
};

export default Login;
